import { Button, Flex, Icons, Modal, Typography } from '@contiple/antd-ds';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

interface CreateOrganizationGuideModalProps {
  open: boolean;
  onClose: () => void;
  onCreate: () => void;
}

export default function CreateOrganizationGuideModal({
  open,
  onClose,
  onCreate,
}: CreateOrganizationGuideModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      closable={false}
      centered
      width={480}
      styles={{
        content: { padding: 0 },
        header: { padding: '32px 32px 20px' },
        body: { padding: '0 32px' },
        footer: { padding: '24px 32px' },
      }}
      title={
        <Flex align="center" gap={8}>
          <Icons.Users size={20} />
          <span>{t('dashboard.createOrgTitle')}</span>
        </Flex>
      }
      footer={
        <Flex vertical gap={16} align="center">
          <Button type="primary" block onClick={onCreate}>
            {t('dashboard.createOrgConfirm')}
          </Button>
          <Text
            type="secondary"
            style={{ cursor: 'pointer' }}
            onClick={onClose}>
            {t('dashboard.createOrgLater')}
          </Text>
        </Flex>
      }>
      <Text type="secondary">
        {t('dashboard.createOrgDesc1')}
        <br />
        {t('dashboard.createOrgDesc2')}
      </Text>
    </Modal>
  );
}
